import { render } from "./BookingsList.vue?vue&type=template&id=2c83ad02&scoped=true"
import script from "./BookingsList.vue?vue&type=script&lang=js"
export * from "./BookingsList.vue?vue&type=script&lang=js"

import "./BookingsList.vue?vue&type=style&index=0&id=2c83ad02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c83ad02"]])

export default __exports__